import React from 'react'

function NoPermissionFound() {
  return (
    <div style={{width: "100vw", height: "100vh"}} className='d-flex justify-content-center align-items-center flex-column'>
        <img src='./assets/noPermissions.png' style={{width: "70vw", height: "70vh"}} alt='no permission'/>
        <button onClick={() => window.location.reload()}>Retry</button>
    </div>
  )
}

export default NoPermissionFound;